// ItemInserir.js
class ItemInserir {
 constructor({  rotulo, nomeColuna, tamanho, tipo, valor,  strong=false, casas_decimais=2, passos="0.01", obrigatorio=false , readonly=false, config_drop_down=null}) {
    this.rotulo = rotulo;
    this.nomeColuna = nomeColuna;
    this.tamanho = tamanho;
    this.tipo = tipo;
    this.obrigatorio=obrigatorio;
    this.readonly=readonly;
    this.config_drop_down=config_drop_down;
    this.casas_decimais=casas_decimais;
    this.passos=passos;
    this.strong=strong;
    this.valor=valor;

  }
  }
  
  // Enum para os tipos
  const Tipo = {
    TEXTO: 'texto',
    NUMERO: 'numero',
    PASSWORD: 'password',
    EMAIL: 'email',
    CPF: 'cpf',
    TELEFONE: 'telefone',
    SELECAO: 'selecao',
    TG: 'tg',
    DECIMAL: 'decimal',
    DIVISOR: 'divisor',
    HIDDEN: 'hidden',
    DATA: 'data',
    TEXTO_VALIDADO: 'texto_validado', 
    NOME_SOBRENOME: 'nome_sobrenome', 
    EMAIL_CONFIRMA: 'email_confirma', 
  };
  

//DAQUI PARA BAIXO É APENAS PARA FACILITAR CRIAR AS TABELAS NO BD CORRESPONDENTE 


const TipoSQL = {
  [Tipo.TEXTO]: 'VARCHAR',
  [Tipo.NUMERO]: 'INT',
  [Tipo.PASSWORD]: 'VARCHAR',
  [Tipo.EMAIL]: 'VARCHAR',
  [Tipo.TELEFONE]: 'VARCHAR',
  [Tipo.SELECAO]: 'VARCHAR',
  [Tipo.TG]: 'VARCHAR',
};


//usar isso quando quiser criar tabelas
//console.log(generateCreateTableSQL("nome_tabela",itens));

function generateCreateTableSQL(tableName, itens) {
  let columns = itens.map(item => {
    let type = TipoSQL[item.tipo] || 'VARCHAR';
    let size = item.tamanho || 255;
    let columnDef = `\`${item.nomeColuna}\` ${type}(${size})`;

    if (item.obrigatorio) {
      columnDef += ' NOT NULL';
    }

    if (item.readonly) {
      columnDef += ' UNIQUE';
    }

    return columnDef;
  });

  // Adicionar colunas padrão
  columns.unshift('`id` INT AUTO_INCREMENT PRIMARY KEY');
  columns.push('`id_empresa` INT NOT NULL');
  columns.push('`inserido_por` VARCHAR(70) NOT NULL');
  columns.push('`deletado` INT NOT NULL');
  columns.push('`inserido_em` TIMESTAMP DEFAULT CURRENT_TIMESTAMP');

  let sql = `CREATE TABLE \`${tableName}\` (\n  ${columns.join(',\n  ')}\n);`;
  return sql;
}


  export { ItemInserir, Tipo, generateCreateTableSQL };
  